import { render } from "./TheHeader.vue?vue&type=template&id=62857571&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "@/assets/styles/header.scss?vue&type=style&index=0&id=62857571&lang=scss&scoped=true"

import exportComponent from "/home/djokic/Projects/mariv/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62857571"]])

export default __exports__